import React from 'react';
import {observer} from "mobx-react";
import {SearchByRecordLocatorStrategy} from "./search-by-record-locator.strategy";
import {StringFieldEditorComponent} from "../../../../components/forms/string-field/string-field-editor.component";
import {BookingSearchFieldsContainerBox} from "../common/booking-search-fields-container.box";

export const SearchByRecordLocatorComponent: React.FC<{strategy: SearchByRecordLocatorStrategy}> = observer((props) => {
    return (
        <BookingSearchFieldsContainerBox>
            <StringFieldEditorComponent field={props.strategy.fields.recordLocator} showClearButton={true}/>
        </BookingSearchFieldsContainerBox>
    );
})